import React from 'react';
import { largeCurrencyFormat, sharesFormat } from 'common/formats/formats';
import { GridDateEditor, GridDateValueViewer } from 'components/FeaturedSpreadsheet/components';
import { LedgerGridDate } from 'components/LedgerTable/components';
import buildAccruedDividendsExpr from 'pages/CapTable/cap-table/utilities/buildAccruedDividendsExpr';

const colConfig = (measurementDate: string) => [
  {
    value: 'Date',
    alias: 'date',
    width: '175px',
    gridDateComponent: LedgerGridDate,
    gridType: 'gridDate',
    dataEditor: (props: any) => <GridDateEditor {...props} />,
    valueViewer: (props: any) => <GridDateValueViewer {...props} />,
    isRequired: true,
  },
  {
    value: 'Shares',
    alias: 'shares',
    width: '175px',
    format: sharesFormat,
    minValue: 1,
    gridType: 'number',
    hasTotal: true,
    isRequired: true,
  },
  {
    value: 'Accrued Dividends',
    alias: 'accrued_dividends',
    width: '175px',
    readOnly: true,
    format: largeCurrencyFormat,
    gridType: 'number',
    isExpr: true,
    expr: buildAccruedDividendsExpr(measurementDate),
    hasTotal: true,
  },
];

export default colConfig;
